import React from "react";
import { Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ContactHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="14645" id="lets-talk-power" className="relative flex min-h-[60vh] items-center justify-center overflow-hidden bg-muted text-foreground py-20">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-muted/95 z-10" />
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603327/img/logistics_geometric_pattern.png)] bg-cover bg-center opacity-10 mix-blend-multiply" aria-hidden="true" />
        {}
        <div className="absolute inset-0 bg-radial-[circle_at_center,_var(--color-primary)_0%,_transparent_70%] opacity-5 z-10" />
      </div>

      {}
      <div ref={ref} className={`relative z-20 container mx-auto px-4 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <div className="mx-auto max-w-4xl space-y-8">
          <h1 className="text-5xl font-extrabold tracking-tighter sm:text-6xl md:text-7xl lg:text-8xl text-primary drop-shadow-sm">
            832-405-3766
          </h1>
          
          <p className="mx-auto max-w-2xl text-lg text-secondary sm:text-xl md:text-2xl font-medium tracking-wide">
            Richmond • Sugar Land • Missouri City • Houston
          </p>

          <div className="flex flex-col items-center justify-center gap-4 sm:flex-row pt-4">
            <Button asChild size="lg" className="h-14 px-10 text-lg font-bold shadow-xl bg-destructive hover:bg-destructive/90 text-white rounded-sm">
              <Link to="tel:8324053766">
                <Phone className="mr-3 h-6 w-6" />
                24/7 Emergency Dispatch
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}